import React from 'react';
import loadable from '@loadable/component';
import LoadingScreen from 'components/LoadingScreen';

const LoadableDriverLicenseError = loadable(
  () => import('./DriverLicenseError'),
  {
    fallback: <LoadingScreen />,
  },
);

export default LoadableDriverLicenseError;
